import { PAID_PLANS } from '../constants/moduleKeys';

/**
 * El plan que el visitante eligió en la landing ("Probar gratis" en la tarjeta de
 * Profesional llega como /register?plan=Profesional). El registro abre una prueba sin
 * tarjeta, así que el plan no se cobra ahí: se recuerda para destacarlo cuando llegue a
 * elegir plan, días después. Antes el parámetro se perdía al registrarse.
 *
 * Vive en localStorage porque es solo una comodidad de este navegador: si se pierde,
 * el dueño elige de nuevo y nada se rompe. Toda lectura/escritura va en try/catch
 * (modo privado o almacenamiento bloqueado).
 */
const KEY = 'massresto.planIntent';

type PaidPlan = (typeof PAID_PLANS)[number];

/** Nombre canónico del plan ("profesional" → "Profesional"), o null si no es un plan de paga. */
export function canonicalPlan(name: string | null | undefined): PaidPlan | null {
  if (!name) return null;
  const normalized = name.trim().toLowerCase();
  return PAID_PLANS.find((p) => p.toLowerCase() === normalized) ?? null;
}

export function savePlanIntent(name: string | null | undefined): void {
  const plan = canonicalPlan(name);
  if (!plan) return;
  try {
    localStorage.setItem(KEY, plan);
  } catch {
    // Sin almacenamiento el plan simplemente no se recuerda.
  }
}

export function readPlanIntent(): PaidPlan | null {
  try {
    return canonicalPlan(localStorage.getItem(KEY));
  } catch {
    return null;
  }
}

export function clearPlanIntent(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nada que limpiar.
  }
}
